import React from 'react';
import './FooterMobile.scss';
import imprivataGraphic from '../../components/Login/Icons/imprivata.svg';

/**
 * Footer for mobile-only component
 * @class FooterMobile
 * @extends {Component}
 */

class FooterMobile extends React.Component {

  render() {
    const footerClass = (iOS()? 'footer-mobile ios-adjustment' : 'footer-mobile');
    return (
      <div className={footerClass}>
        <div className={'bottom-divider'}> </div>
        <img src={imprivataGraphic} className={'imprivata-logo'} alt='logo'/>
      </div>
    );
  }
}


// iOS() ? "footer-mobile ios-adjustment" : "footer-mobile"
// doing this to raise the logo
function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}


export default FooterMobile;
